module.exports = __webpack_public_path__ + "static/img/android_.6a1353b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android_.png
// module id = UuCq
// module chunks = 1